import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "Options",
    serverType: "dropMenu",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "Options",
            title: "",
            isNeed: false,
            options: []
        };
    },
    checkContent(content) {
        if (!content.title) {
            throw new ParamError(i18n.t("zhiji.form.options.error.title"));
        }
        if (content.options) {
            let options = content.options;
            options.map(option => {
                if (!option.label) {
                    throw new ParamError(i18n.t("zhiji.form.options.error.tip"));
                }
            });
        }
    },
    // 后台数据转前端数据
    server2Client(content) {
        return {
            uId: uniqueId(),
            num: content.num,
            wtType: "Options",
            updateState: "",
            title: content.title,
            isNeed: content.is_need,
            options: content.options
        };
    },
    // 前端数据转后台数据
    client2Server(content) {
        return {
            num: 0,
            title: content.title,
            type: "dropMenu",
            name: "dropMenu",
            is_need: content.isNeed,
            tip: "",
            value: "",
            readonly: "false",
            options: optionAssign(content.options)
        };
    }
};

function optionAssign(options = []) {
    return options.map((option, index) => {
        return Object.assign(option, {
            value: "" + (index + 1),
            link_option: "",
            selected: false
        });
    });
}
